module.exports = __webpack_public_path__ + "img/T1C_rc_25.9f98961a.png";